import Talent from './talent';
import { Talents, TalentField } from '../character/allValues';
import TalentFieldObject from './talentFieldObject';

export default class TalentCollection {
  public allTalents: Talent[] = Talents;

  public getAllTalentFields(): TalentFieldObject[] {
    return [
      { name: 'Körper', id: TalentField.Körper },
      { name: 'Gasse', id: TalentField.Gasse },
      { name: 'Geist', id: TalentField.Geist },
      { name: 'Mystik', id: TalentField.Mystik },
      { name: 'Wildnis', id: TalentField.Wildnis },
      { name: 'Wissen', id: TalentField.Wissen },
    ];
  }

  public getTalentsByTalentField(field: TalentField) {
    return this.allTalents.filter((talent) => talent.talentField === field);
  }
}
